
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "Form1",
  components: {},
  props: {
    callbackdata: {
      type: Object,
      default: false
    }
  },
  watch: {
    callbackdata(newone, oldone) {
      if (newone.input_CarSignNum != this.inputModel.input_CarSignNum) {
        this.inputModel = newone;
      } else if (
        newone.input_SignatureStatue != this.inputModel.input_SignatureStatue
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_MidSignatureNum != this.inputModel.input_MidSignatureNum
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_LastSignatureNum != this.inputModel.input_LastSignatureNum
      ) {
        this.inputModel = newone;
      } else if (
        newone.input_ReasonForSignatureStatue !=
        this.inputModel.input_ReasonForSignatureStatue
      ) {
        this.inputModel = newone;
      }
    }
  }
})
export default class extends Vue {
  private inputModel: inputDataModel_ResolveCar = {
    input_ScanCode: "",
    input_CarSignNum: "",
    input_SignatureStatue: "",
    input_MidSignatureNum: "",
    input_LastSignatureNum: "",
    input_ReasonForSignatureStatue: ""
  };
  public Options_SignatureStatue = [
    // {
    //   value: "选项1",
    //   label: "完好",
    // },
  ];
  mounted() {
    this.$emit("get-form1-value", this.inputModel);

    var ioTypes = obj_ScanForResolveCar.checkIoType(this.CheckIoTypeCallBack);
  }
  @Watch("inputModel", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form1-value", val);
  }
  public CheckIoTypeCallBack(data) {
    if (data != null && data.ioTypes != null) {
      this.Options_SignatureStatue = data.ioTypes.map(item => {
        return { value: `${item}`, label: `${item}` };
      });
      this.inputModel.input_SignatureStatue = "完好";
    }
  }

  //显示信息栏
  public messageboxShow(type, msg): void {
    // info
    // warning
    // success
    // error
    this.$message({
      message: msg,
      type: type
    });
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  //表格选中当前行
  public setCurrent(row) {
    // this.$refs.singleTable.setCurrentRow(row);
    this.$refs.singleTable[0].setCurrentRow();
  }

  public loading_DestinationOrg = false;
  public loading_LineData = false;
  public list_LineData = [];
  public options = [];
  private form = null;
  private errormessage = "";
}
